<template>
    <div>
        <EventView
            :me="$store.state.me"
            :slug="$route.params.slug"
            :isPaymentsEnabled="$store.state.billingTurnedOn"
            :key="renderingkey"
        />
    </div>
</template>

<script>
import EventView from '@/components/Templates/User/Event/View/EventView.vue';

export default {
    name: 'CoViewEvent',
    components: {
        EventView,
    },
    data() {
        return {
            renderingkey: 0,
        };
    },
    beforeRouteUpdate(to, from, next) {
        // called when the route that renders this component has changed,
        // but this component is reused in the new route.
        // For example, for a route with dynamic params `/foo/:id`, when we
        // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
        // will be reused, and this hook will be called when that happens.
        // has access to `this` component instance.
        if (to.params.slug !== from.params.slug) {
            this.renderingkey++;
        }
        next();
    },
};
</script>
